'use client';

import { List } from '@wolfejs/ui/List';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { ReportItem } from './ReportItem';
import type { ReportItemProps } from './types';

type ReportsListProps = {
  reports: ReportItemProps[];
};

export const ReportsList = ({ reports }: ReportsListProps) => {
  const { portalSlug } = useParams();
  return (
    <List
      className="flex-col gap-4"
      listItems={reports}
      renderComponent={data => (
        <Link href={`/${portalSlug}/reports/${data.type}`}>
          <ReportItem {...data} />
        </Link>
      )}
    />
  );
};
